import { render } from "./Promo202111.vue?vue&type=template&id=73c4eeb6&scoped=true"
import script from "./Promo202111.vue?vue&type=script&lang=js"
export * from "./Promo202111.vue?vue&type=script&lang=js"

import "./Promo202111.vue?vue&type=style&index=0&id=73c4eeb6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c4eeb6"]])

export default __exports__